import { Island } from '../island.class';
import { Size } from '../../../types';

export const getOverallSizeCfn = (island: Island): Size => {
	// NOTE: Doesn't take into considuration corner island angle
	const { islandSize, panels } = island;

	const pFront = panels.getFrontPanel();
	const pLeft = panels.findById(pFront.connections.left.targetPanelId);
	const pRight = panels.findById(pFront.connections.right.targetPanelId);

	// Get back panels by filtering for actual back panels (not the front panel looping back)
	const backPanels = panels.children.filter((p) => p.isBackPanel);
	const maxBackOverhang = backPanels.length > 0
		? Math.max(...backPanels.map((p) => p.countertopOverhang))
		: pFront.countertopOverhang;

	return {
		width: islandSize.width + pLeft.countertopOverhang + pRight.countertopOverhang,
		height: islandSize.height + island.panels.surroundMaterial.thickness,
		depth: islandSize.depth + pFront.countertopOverhang + maxBackOverhang
	};
};
